let inlineApiUrl = "fill-dynamicly";

export function setInlineApiUrl(url: string) {
  inlineApiUrl = url;
}

export function getInlineApiUrl() {
  return inlineApiUrl;
}
